// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"a22c0318","412":"fa2c5353","439":"be59f8dc","833":"da060297"}[chunkId] + ".chunk.js";
};